import type { RouteRecordRaw } from 'vue-router'

const routes: RouteRecordRaw[] = [
    {
        path: '/roles',
        component: () => import('@/layouts/ModuleLayout.vue'),
        meta: {
            moduleKey: 'settings.users',
        },
        children: [
            {
                path: '',
                name: 'RoleList',
                component: () => import('./views/RoleList.vue'),
            },
            {
                path: 'create',
                name: 'RoleCreate',
                component: () => import('./views/RoleCreate.vue'),
                meta: {
                    moduleKey: 'settings.users',
                },
            },
            {
                path: ':id',
                name: 'RoleDetail',
                component: () => import('./views/RoleDetail.vue'),
                props: true,
            },
        ],
    },
]

export default routes
